import { PayloadAction } from "app/core/models/action";
import { Commodity } from 'app/profile/models/site.model';

export const GET_COMMODITIES = "[PRODUCT] GET_COMMODITIES";
export const GET_COMMODITIES_SUCCESS = "[PRODUCT] GET_COMMODITIES_SUCCESS";
export class GetCommodities implements PayloadAction {
    readonly type = GET_COMMODITIES;
    constructor(public payload?: string) {}
}

export class GetCommoditiesSuccess implements PayloadAction {
    readonly type = GET_COMMODITIES_SUCCESS;
    constructor(public payload: Commodity[]) {}
}

export type ProductActions =
    | GetCommodities
    | GetCommoditiesSuccess;
